// @mui
import { Box, Button, Tab, Tabs, Typography, useTheme } from '@mui/material';
// components

import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { Fragment, useEffect, useMemo } from 'react';
import { Page } from 'theme/elements/Page';
import { useAppDispatch } from 'hooks/redux.hooks';
import { getNewAccounts } from 'services/new_accounts.service';
import { getError, setError } from 'state/reducers/new_accounts.reducers';
import { PendingAccounts } from 'sections/NewAccounts/Pending';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { WarningDialog } from 'components/WarningDialog';

export const AccountsInProcess = () => {
	const pagePermission = hasPermission([permissionEnums.IN_PROGRESS_ACCOUNTS]);
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const newAccountError = useAppSelector(getError);

	const openDialog = useMemo(() => {
		return newAccountError?.exist;
	}, [newAccountError]);
	return (
		<Page title={t('page.accounts.new_account.header.title')}>
			<Fragment>
				<WarningDialog
					open={openDialog}
					subTitle={t(newAccountError?.text || '')}
					handleCancel={() => {
						dispatch(setError({ exist: false }));
					}}
				/>
				<PendingAccounts />
			</Fragment>
		</Page>
	);
};
